module.exports = __webpack_public_path__ + "static/media/btn_close.ea35bc37.png";